angular
	.module('preventiveTable.components', ['app.services'])
	.component('preventiveTable', {
		templateUrl: 'ng/components/preventiveTable/preventiveTable.view.html',
		controllerAs: 'PreventiveTableCtrl',
		bindings: {
			identifierAppCustomer: '='
		},
		controller: function (
			$scope,
			HttpService,
			$rootScope,
			FileUploader,
			$location,
			validationService,
			$searchUserService,
			$contractService,
			FactoryObj,
			$filter,
			$modalService,
			$timeout,
			$featureService,
			$configService,
			$financialService,
			$sharedService,
			$download
		) {

			$scope.ArfDigitalSign = $featureService.ArfDigitalSign();
			$scope.ArfPrintContractDetail = $featureService.ArfPrintContractDetail();
			/** this refererence depends from context */
			var self = this;

			self.validationService = validationService;

			self.searchUserService = $searchUserService;

			self.getListAppContractWorks = false;

			self.$onInit = function () {

				self.getContractStatusList();
				getListAppPreventive(self.identifierAppCustomer);

			}

			$rootScope.$on("refreshListAppContract", function (event, args) {
				console.log("BROADCAST CALL - refreshListAppContract - self.getListAppContractWorks=" + self.getListAppContractWorks);
				if (!self.getListAppContractWorks) {
					self.getListAppContractWorks = true;
					getListAppPreventive(args.identifierAppCustomer);
				}

			});

			$rootScope.$on("refreshListAppTotalContract", function (event) {
				console.log("BROADCAST CALL - refreshListAppContract - self.getListAppContractWorks=" + self.getListAppContractWorks);
				if (!self.getListAppContractWorks) {
					self.getListAppContractWorks = true;
					self.getListAppTotalPreventive();
				}

			});

			self.propMap = propMap;



			self.goToContractDocumentation = function (contractItem) {
				FactoryObj.selectedContract = contractItem;
				// leasingConfiguration and searchUser controllers are listening and will change navigator.viewIndex to 1
				$scope.$emit("goToContractDocumentation", {});
			}

			self.searchUserObj = {
				appFinancialPreventiveList: []
			};

			self.filterAllPreventive = {
				appFinancialPreventive: {
					limit: '4',
					offset: 0,
					pageIndex: 1,
					totalPages: 0,
					orderColumnName: 'UPDATE_DATE',
					orderType: 'DESC',
					identifierAppCustomer: null,
					identifierAppVendor: null
				}
			};

			/** Set true only if the search method ever returned */
			self.searchReturned = false;


			self.mapContractStatus = {};

			self.getContractStatusList = function () {
				HttpService.send('/uni/typedomain/getDomainSet', {
					table: 'APP_CONTRACT',
					column: 'CONTRACT_STATUS'
				}, false).then(function (response) {
					self.contractStatusList = response.domainList;

					angular.forEach(self.contractStatusList, function (item) {

						switch (item.value) {
							case $rootScope.propMap['CONTRACT_STATUS_SPRINT_START']:
							case $rootScope.propMap['CONTRACT_STATUS_SPRINT_END']:
								// IN LAVORAZIONE ALBA
								self.mapContractStatus[item.value] = self.contractStatusList.find(function (el) {
									return el.value == $rootScope.propMap['CONTRACT_STATUS_CREATED'];
								}).name;
								break;
							case $rootScope.propMap['CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE']:
							case $rootScope.propMap['CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE_CHECKED']:
							case $rootScope.propMap['CONTRACT_STATUS_CHOSEN_MANUAL_SIGNATURE']:
								//DELIBERATO
								self.mapContractStatus[item.value] = self.contractStatusList.find(function (el) {
									return el.value == $rootScope.propMap['CONTRACT_STATUS_DELIBERATED'];
								}).name;
								break;
							case $rootScope.propMap['CONTRACT_STATUS_CONTRACT_STIPULATED']:
							case $rootScope.propMap['CONTRACT_STATUS_CONTRACT_STIPULATED_FINAL']:
								//SIGNED
								self.mapContractStatus[item.value] = self.contractStatusList.find(function (el) {
									return el.value == $rootScope.propMap['CONTRACT_STATUS_SIGNED'];
								}).name;
								break;
							default:
								self.mapContractStatus[item.value] = item.name;
								break;
						}

					})
					console.log('self.contractStatusList: ', self.contractStatusList);
				});
			}

			var getListAppPreventive = function (identifierAppCustomer) {

				//called by broadcast
				if (identifierAppCustomer) {
					self.filterAllPreventive.appFinancialPreventive.identifierAppCustomer = self.identifierAppCustomer;
					if ($rootScope.context == 'portal-list/ara/') {
						self.filterAllPreventive.appFinancialPreventive.identifierAppVendor = $configService.getUser().identifier;
					}
				}

				$financialService.getListAppPreventive(self.filterAllPreventive)
					.then(function (response) {
						self.getListAppContractWorks = false;
						var appFinancialPreventiveList = response && response.allListAppFinancialPreventive;
						var totalCount = response && response.totalCount;
						self.filterAllPreventive.appFinancialPreventive.totalPages = getSTotalPages(totalCount);
						self.searchUserObj.appFinancialPreventiveList = [];
						self.searchUserObj.appFinancialPreventiveList = addEmptyRow(appFinancialPreventiveList);
						console.log('appFinancialPreventiveList LENGTH: ', self.searchUserObj.appFinancialPreventiveList.length);
					})
			}


			//To retrieve all the total contracts
			var getListAppTotalPreventive = function () {

				//called by broadcast

				self.filterAllPreventive.appFinancialPreventive.identifierAppCustomer = null;
				self.filterAllPreventive.appFinancialPreventive.identifierAppVendor = $configService.getAppConfig().user.identifier;

				$contractService.getAllTotalPreventive(self.filterAllPreventive)
					.then(function (response) {
						self.getListAppContractWorks = false;
						var preventiveList = response && response.allAppPreventiveList;
						var totalCount = response && response.allAppPreventiveListCount;
						self.filterAllPreventive.appFinancialPreventive.totalPages = getSTotalPages(totalCount);

						$scope.searchUserObj = [];
						$scope.searchUserObj.appFinancialPreventiveList = [];
						$scope.searchUserObj.appFinancialPreventiveList = addEmptyRow(preventiveList);
						console.log('contractList LENGTH: ', $scope.searchUserObj.appFinancialPreventiveList.length);

					})
			}



			//update table getAllSimulations
			self.updateOrderTableSimulation = function (ordColName, ordType) {
				self.filterAllPreventive.appFinancialPreventive.orderColumnName = ordColName;
				self.filterAllPreventive.appFinancialPreventive.orderType = ordType;
				getListAppPreventive();

			}

			self.pageSIndexIndietro = function (value) {
				if (value == 'init') {
					self.filterAllPreventive.appFinancialPreventive.pageIndex = 1;
				} else {
					if (self.filterAllPreventive.appFinancialPreventive.pageIndex > 1) {
						self.filterAllPreventive.appFinancialPreventive.pageIndex--;
					}
				}
				updateOffsetAndSearch();
			}

			self.pageSIndexAvanti = function (value) {
				if (value == 'end') {
					//subito pagina finale
					self.filterAllPreventive.appFinancialPreventive.pageIndex = self.filterAllPreventive.appFinancialPreventive.totalPages;
				} else {
					//avanzo +1
					if (self.filterAllPreventive.appFinancialPreventive.pageIndex < self.filterAllPreventive.appFinancialPreventive.totalPages) {
						self.filterAllPreventive.appFinancialPreventive.pageIndex++;
					}
				}
				updateOffsetAndSearch();
			}

			self.checkNotNull = function (codeValue, objStringToCheck) {
				if (objStringToCheck) {
					return $filter('translate')(codeValue);
				}
				return null;
			}

			/** Extract information from metadata and return a string with a list of product infos **/
			self.prepareGoodTypeBrandConcat = function (metadata) {
				if (metadata) { // consider only not empty row!
					var metadataObj = metadata;
					var finalConcatString = "";
					if (metadataObj.leasingObj != null &&
						metadataObj.leasingObj.leasingItems != null &&
						metadataObj.leasingObj.leasingItems.length > 0) {
						for (var index = 0; index < metadataObj.leasingObj.leasingItems.length; index++) {
							var prodItem = metadataObj.leasingObj.leasingItems[index];
							var separator = ", ";
							if (finalConcatString.length == 0) {
								separator = "";
							}
							finalConcatString += separator + prodItem.brand + " " + prodItem.goodType;
						}
					}
					return finalConcatString;
				}
			}

			function updateOffsetAndSearch() {
				self.filterAllPreventive.appFinancialPreventive.offset = (self.filterAllPreventive.appFinancialPreventive.pageIndex - 1) * self.filterAllPreventive.appFinancialPreventive.limit;
				getListAppPreventive();
			}

			function getSTotalPages(totalCount) {
				//se il resto è zero non va aggiunto +1
				var addPlusOneToTotal = 0;
				var totModuloResult = totalCount % Number(self.filterAllPreventive.appFinancialPreventive.limit);
				if (totModuloResult > 0) {
					addPlusOneToTotal = 1;
				}
				return (Math.floor(totalCount / Number(self.filterAllPreventive.appFinancialPreventive.limit))) + addPlusOneToTotal;
			}

			function addEmptyRow(restList) {
				var outputList = [];
				var indexRestList = Number(self.filterAllPreventive.appFinancialPreventive.limit);
				if (restList != null) {
					outputList = restList;
					indexRestList = Number(self.filterAllPreventive.appFinancialPreventive.limit) - restList.length;
				}

				if (indexRestList > 0) {
					for (var irl = 0; irl < indexRestList; irl++) {
						outputList.push({});
					}
				}
				return outputList;
			}

			// PAGINATION END

			self.getFromDomain = function (value, list, delay, cb) {
				$timeout(function () {
					HttpService.send('/uni/typedomain/getDomainSet', {
						table: 'RI_DROPDOWN_DOMAINS',
						column: value
					}, false)
						.then(function (response) {
							self.dropdown[list] = response.domainList;

							if (cb) {
								cb();
							}
						});
				}, delay);
			}
			self.dropdown = {};
			self.getFromDomain('DOCUMENT_TYPE', 'tipiDocumento', 0);


			self.viewDocument = function (signer) {
				$modalService.openModal('documentoRiconoscimentoFirmatario');
				self.documentData = signer.documento;
				//			self.documentData.tipo = self.dropdown.tipiDocumento.find(function(el){
				//				return el.value.toUpperCase() === self.documentData.tipo.toUpperCase();
				//			}).name;
				/// check 
				if (!self.documentData.name) {
					self.documentData.name = self.dropdown.tipiDocumento.find(function (el) {
						return el.value.toUpperCase() === self.documentData.tipo.toUpperCase();
					}).name;
				}
				self.documentData.tipo = self.dropdown.tipiDocumento.find(function (el) {
					return el.value.toUpperCase() === self.documentData.tipo.toUpperCase();
				}).value;
			}

			self.checkDigitalSignature = function (signer) {
				signer.checkedDigitalSignature = !signer.checkedDigitalSignature;
			}

			self.printContract = function (contract) {
				self.updateSignatureMethod(propMap['CONTRACT_STATUS_CHOSEN_MANUAL_SIGNATURE_PRINTED'], contract);
				self.contractPrinted = true;
			}

			self.updateSignatureMethod = function (newStatus, contract) {
				$contractService.updateContractStatus(newStatus, contract)
					.then(function (updateOk) {
						if (updateOk) {
							//reload contracts
							getListAppContract();
						}
					})
			}



			self.updateContractMetadata = function (contract) {
				if (self.allSignerSelected(contract)) {
					self.updateSignatureMethod(propMap['CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE_CHECKED'], contract);
				}
				$contractService.updateContractMetadata(contract)
					.then(function (updateOk) {
						if (updateOk) {
							//reload contracts
							getListAppContract();
							closeModal();
						}

					})
			}

			/** returns true if all selected signers have have been checked **/
			self.allSignerSelected = function (contract) {
				var notCheckedSigners = contract && contract.metadataContract.listaPf
					.filter(function (pf) {
						return pf.firmatario.selected;
					})
					.filter(function (selectedSigner) {
						return !selectedSigner.checkedDigitalSignature;
					});

				if (notCheckedSigners && notCheckedSigners.length === 0) {
					return true;
				}
				return false;
			}

			/** returns true if has been selected at least 1 signer **/
			self.atLeastOneSignerSelected = function () {
				var checkedSigners = self.selectedContract &&
					self.selectedContract.metadataContract.listaPf
						.filter(function (pf) {
							return pf.firmatario.selected;
						})
						.filter(function (selectedSigner) {
							return selectedSigner.checkedDigitalSignature;
						});

				if (checkedSigners && checkedSigners.length >= 1) {
					return false;
				}
				return true;
			}

			var addUsers = function () {
				self.closeConfirmModal();

				$contractService.addUsers(self.selectedContract)
					.then(function (updateOk) {
						if (updateOk) {
							console.log('returned!');
							getListAppContract();
						}
					})
			}

			self.confirmSigners = function () {
				addUsers();
				self.closeConfirmModal();
				self.updateSignatureMethod(propMap['CONTRACT_STATUS_WAITING_FOR_SIGNATURE'], self.selectedContract);
			}
			self.goToRealConfirm = function () {
				self.swConfirm = true;
			}

			self.openModal = function (contract) {
				self.swConfirm = false;
				self.selectedContract = contract;
				$('#signers-inner-contract-table-modal').modal('show');
			}

			self.openConfirmModal = function (contract) {
				self.selectedContract = contract;
				$('#signers-inner-contract-table-modal-confirm').modal('show');
			}

			self.goToUploadAdditionalDocs = function (contract) {
				$rootScope.goTo('/uploadAdditionalDocs/' + contract.idContract + '/' + contract.idSimulation + '/' + contract.metadataContract.numPreventivo);
			}



			var closeModal = function () {
				$('#signers-inner-contract-table-modal').modal('hide');
				$('body').removeClass('modal-open');
				$('.modal-backdrop').remove();
			}

			self.closeConfirmModal = function () {
				$('#signers-inner-contract-table-modal-confirm').modal('hide');
				$('body').removeClass('modal-open');
				$('.modal-backdrop').remove();
			}

			/************************************************************
			 *  UPLOADER
			 ************************************************************/
			self.uploadDataFunc = function (contract) {
				self.uploadData = contract.idSimulation;
				self.contract = contract;
			}

			self.uploader = new FileUploader({
				url: '',
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Token': 'Bearer ' + ($configService.getAppConfig().token || 'no-token'),
					'App-Name': $rootScope.portalName
				}
			});
			self.finalUpload = function (uploadData) {
				var url;
				url = $configService.getAppConfig().url + '/simulator/upload/service-infos/' + encodeURIComponent(uploadData) + '/MANUAL-SIGNATURE/';

				for (var int = 0; int < self.uploader.queue.length; int++) {
					self.uploader.queue[int].url = url;
				}
				self.uploading = true;
				self.uploader.uploadAll();
			}

			self.generateDownloadLink = function (filename, directory) {
				var url = '/simulator/download/service-infos/' +
					encodeURIComponent(FactoryObj.simulationItem.id) + '/' +
					encodeURIComponent(directory) + '/' +
					encodeURIComponent(filename) + '/'

				$download.getGenericDownload(url)
					.then(function (response) {
						console.log(response);
					})
			}

			self.uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
				console.info('onWhenAddingFileFailed', item, filter, options);
			};

			self.uploader.onAfterAddingFile = function (fileItem) {
				console.log('fileItem', fileItem);
				var fileName = fileItem.file.name;
				if (fileName.toLowerCase().indexOf('.pdf') > -1 || fileName.toLowerCase().indexOf('.png') > -1 || fileName.toLowerCase().indexOf('.jpg') > -1 || fileName.toLowerCase().indexOf('.jpeg') > -1) {
					self.uploader.queue[0].progress = 0;
				} else {
					fileItem.remove();
					$('#input-upload-' + self.currentCodeTypeNameIndex).val('');
					$rootScope.$broadcast('addAlert', {
						text: 'FORMAT_NOT_SUPPORTED'
					});

				}
			};

			self.uploader.onAfterAddingAll = function (addedFileItems) {
				console.info('onAfterAddingAll', addedFileItems);
				self.finalUpload(self.uploadData);
			};

			self.uploader.onBeforeUploadItem = function (item) {
				item.file.name = window.encodeURIComponent(item.file.name);
				item.headers['Token'] = 'Bearer ' + $configService.getAppConfig().token;
			};

			self.uploader.onProgressItem = function (fileItem, progress) {
				self.uploadCompleted = false;
			};

			self.uploader.onProgressAll = function (progress) { };

			self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
				self.uploading = false;
			};

			self.uploader.onErrorItem = function (fileItem, response, status, headers) {
				console.info('onErrorItem', fileItem, response, status, headers);
				$rootScope.$broadcast('addAlert', {
					text: 'ERROR_UPLOADING_FILE'
				});
			};

			self.uploader.onCancelItem = function (fileItem, response, status, headers) { };

			self.uploader.onCompleteItem = function (fileItem, response, status, headers) {
				console.info('onCompleteItem', fileItem, response, status, headers);
				if (response.success) {
					//alert("ok!");
					console.log(fileItem);
					$rootScope.$broadcast('addAlert', {
						text: 'UPLOAD_SUCCESS'
					});

				}

				self.uploader.queue = [];
			};

			self.uploader.onCompleteAll = function () {
				console.info('onCompleteAll');
				self.uploadCompleted = true;
				self.updateSignatureMethod(propMap['CONTRACT_STATUS_SIGNED'], self.contract);
			};

			self.generateDownloadLink = function (item) {
				var url = '/simulator/contract/downloadZip/service-infos/' +
					encodeURIComponent("NUMEROCONTRATTO") +
					'/' +
					encodeURIComponent("MODULO") +
					'/'

				$download.getGenericDownload(url)
					.then(function (response) {
						console.log(response);
					})
			}

			/**
			 * Called download detail document contract
			 */

			self.downloadPdfDetailContract = function (idContract) {
				console.log('clicked');
				var url = '/simulator/printContractDetails/service-infos/' +
					encodeURIComponent(idContract) +
					'/CONTRACT/'

				$download.getGenericDownload(url)
					.then(function (response) {
						console.log(response);
					})
			}


			self.riprendi = function (item) {

				$sharedService
					.setSimulation(item.metadata.financialModel)

				$location.path('/financialLeasing')

			}
		}
	});